import React, { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import { Attachment } from 'core/domain/expenses/attachment'

import FormikCheckboxField from 'common/components/dataEntry/formik/FormikCheckboxField'
import Icon from 'common/components/general/Icon'

import './AttachmentPreview.less'

interface UploadFileProps {
  file: File
  saveForLater?: boolean
  id: number
}

interface AttachmentPreviewProps {
  uploadedFile?: UploadFileProps
  attachment?: Attachment
  deletable?: boolean
  onDelete?: () => void
  showSaveForLater?: boolean
  onSaveForLaterChange?: (checked: boolean) => void
  className?: string
}

const AttachmentPreview: React.FC<AttachmentPreviewProps> = (props) => {
  const [imageSource, setImageSource] = useState<string>()
  const [saveForLaterChecked, setSaveForLaterChecked] = useState<boolean>(props.uploadedFile?.saveForLater ?? false)
  const { t: translate } = useTranslation('ee-dashboard')

  useEffect(() => {
    if (props.uploadedFile) {
      var reader = new FileReader()
      reader.onload = function (e: any) {
        setImageSource(e.target.result)
      }
      reader.readAsDataURL(props.uploadedFile.file)
    }
  }, [props.uploadedFile?.file])

  useEffect(() => {
    if (props.uploadedFile) {
      setSaveForLaterChecked(props.uploadedFile.saveForLater ?? false)
    }
  }, [props.uploadedFile?.saveForLater])

  const closeContent = (): ReactNode => {
    return props.deletable ? (
      <Icon
        type="fa fa-times"
        fontAwesome
        className="close_icon"
        onClick={() => {
          if (props.onDelete) props.onDelete()
        }}
      />
    ) : null
  }

  const saveForLaterContent = (): ReactNode => {
    if (props.showSaveForLater) {
      return (
        <div>
          <FormikCheckboxField
            name="saveForLater"
            onChange={(e: any) => {
              if (props.onSaveForLaterChange) {
                props.onSaveForLaterChange(e.target.checked)
                setSaveForLaterChecked(e.target.checked)
              }
            }}
            checked={saveForLaterChecked}
          />{' '}
          <label htmlFor="saveForLater">{translate('get-reimburse.request.save-in-library-label')}</label>
        </div>
      )
    }
    return null
  }

  const getThumbnailContent = (): ReactNode => {
    if (props.uploadedFile) {
      if (['image/jpeg', 'image/png'].indexOf(props.uploadedFile.file.type) !== -1) {
        return <img src={imageSource} className="thumbnail mr-8" />
      } else {
        return <Icon type="fa fa-file-alt" fontAwesome className="file_thumbnail mr-8" />
      }
    } else {
      return <img src={props.attachment?.fileNameUrl} alt={props.attachment?.title} className="thumbnail mr-8" />
    }
  }

  const getFileTitle = (): string => {
    if (props.attachment) {
      return props.attachment.title
    } else if (props.uploadedFile) {
      return props.uploadedFile.file.name
    }
    return ''
  }

  return (
    <Row className={`p-8 attachment_preview ${props.className}`}>
      <Col span={24} className="preview_container">
        <div className="file_details_container">
          {getThumbnailContent()}
          <div>
            <h6>{getFileTitle()}</h6>
            {saveForLaterContent()}
          </div>
        </div>
        {closeContent()}
      </Col>
    </Row>
  )
}

export default AttachmentPreview
